import {ContratoInformacao} from "@components/contratos/ContratoInformacao.tsx";
import {OrcamentoPage} from "@components/orcamento/pages/OrcamentoPage.tsx";
import {RecursosMovimentacoesV2Page} from "@components/recurso/pages/movimentacoes/RecursosMovimentacoesV2Page.tsx";
import {SolicitacaoItemInformacaoGrid} from "@components/solicitacoes/itens/SolicitacaoItemInformacao.tsx";
import {SolicitacaoItensPage} from "@components/solicitacoes/pages/solicitacoes/Itens/SolicitacaoItensPage.tsx";
import {SolicitacaoInfo, SolicitacaoInformacaoGrid} from "@components/solicitacoes/solicitacao/SolicitacaoInfo.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {_SolicitacoesEndpoints, GetItensSolicitacao,} from "@localization/siteMap/endpoints/_SolicitacoesEnpoints.ts";
import {ISolicitacao, ISolicitacaoItem} from "@models/solicitacoes/solicitacoes.ts";
import {Clear, LinkOffOutlined, LinkOutlined, MoneyOff, ShoppingBag, TaskAltOutlined} from "@mui/icons-material";
import {Badge, Divider, Grid, IconButton, Paper, Tab, Tabs, Tooltip, Typography} from "@mui/material";
import {OrcamentosPage} from "@pages/pendencias/Orcamentos/OrcamentosPage.tsx";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useEffect, useMemo, useState} from "react";
import {createSearchParams, useLocation, useNavigate, useSearchParams} from "react-router";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {ProdutoInformacaoNavLink} from "@components/produtos/ProdutoInformacao.tsx";
import {useProduto} from "@components/produtos/hooks/useProduto.ts";
import {IProduto} from "@models/produtos/produto.ts";
import {IOrcamentoFiltroDto} from "@models/solicitacoes/orcamentoDto.ts";
import {SolicitacaoLogsPage} from "@components/solicitacoes/pages/SolicitacaoLogsPage.tsx";
import {useSolicitacao} from "@components/solicitacoes/hooks/useSolicitacao.tsx";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {SolicitacaoReferenciasPage} from "@components/solicitacoes/pages/referencias/SolicitacaoReferenciasPage.tsx";

type tabs =
    'Itens'
    | 'Orcamentos'
    | 'ItemSelecionado'
    | 'Detalhes'
    | 'Contrato'
    | 'ContaContabil'
    | 'Orcamento'
    | 'DetalhesItem'
    | 'Movimentacoes'
    | 'Logs';

interface SolicitacaoPageProps extends DefaultPageProps {
}


export function SolicitacaoPage(_props: SolicitacaoPageProps) {
    const {Get} = useApi();
    const {getProdutosV2} = useProduto()
    const {getReferenciasItens} = useSolicitacao()
    const {addPopUp} = useAlert()

    const [tab, setTab] = useState<tabs>('Itens');
    const [solicitacao, setSolicitacao] = useState<ISolicitacao | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [refreshRequested, setRefreshRequested] = useState(false);
    const [itemSelecionado, setItemSelecionado] = useState<ISolicitacaoItem | null>(null);
    const [produto, setProduto] = useState<IProduto | undefined>();
    const [referencias, setReferencias] = useState<IPagination>({page: 1, pageSize: 0, total: 0})

    const solicitacaoId = searchParams.get("solicitacaoId");
    const itemId = searchParams.get("itemId");
    const produtoId = searchParams.get("produtoId");
    const orcamentoId = searchParams.get("orcamentoId");
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        setTab(location.hash.slice(1) as tabs || 'Detalhes');
    }, [location.hash]);

    useEffect(() => {
        if (solicitacaoId == null) return;
        Get(_SolicitacoesEndpoints.GetSolicitacoes({
            id: [Number(solicitacaoId)],
            deveIncluir: ['UsuarioCriador', 'TipoSolicitacao', 'Forms', 'Contrato', 'Recurso', 'ContaContabil', 'QuickFixes'],
            layers: ['ValorEfetivado', 'ValorPendente', 'ItensPendentes', 'ItensFinalizados'],
        }, {page: 1, pageSize: 1}), refreshRequested).then(x => {
            if (x.status == 'Success') {
                const solicitacao = x.items.find(x => x.id == Number(solicitacaoId));
                if (solicitacao) {
                    setSolicitacao(solicitacao);
                }
            }
        }).finally(() => {
            setRefreshRequested(false)
        });
    }, [solicitacaoId, refreshRequested]);
    useEffect(() => {
        if (itemId == null) return;
        if (solicitacaoId == null) return;
        if (itemSelecionado != null) return;

        Get(GetItensSolicitacao({idItem: [Number(itemId)], idSolicitacao: [Number(solicitacaoId)]}, {
            page: 1,
            pageSize: 1,
        })).then(x => {
            if (x.status == 'Success') {
                const item = x.items.find(x => x.id == Number(itemId));
                if (item) {
                    setItemSelecionado(item);
                }
            }
        });

    }, [itemId, solicitacaoId, itemSelecionado, refreshRequested]);

    useEffect(() => {
        if (itemId == null) return;

        getReferenciasItens({
            data: {idItem: Number(itemId)}, pagination: {
                page: 1,
                pageSize: 10
            }
        }).then(x => {
            setReferencias(prev => ({...prev, ...x.pagination}))
        })
    }, [itemId]);

    useEffect(() => {
        if (produtoId != null) {
            getProdutosV2({
                data: {
                    id: [Number(produtoId)],
                }, pagination: {page: 1, pageSize: 1},
            }).then(x => {
                if (x.items.length > 0) {
                    setProduto(x.items[0])
                } else {
                    setProduto(undefined)
                }
            })
        } else {
            setProduto(undefined)
        }
    }, [produtoId]);

    const orcamentoFiltros = useMemo<IOrcamentoFiltroDto>(() => {
        if (itemId == null) return {
            idSolicitacao: [Number(solicitacaoId)],
        };
        return ({
            idSolicitacao: [Number(solicitacaoId)],
            idItem: [Number(itemId)],
        } as IOrcamentoFiltroDto)
    }, [itemId, orcamentoId, solicitacaoId]);

    return (
        <DefaultContainer titulo={`Detalhes da solicitação ${solicitacaoId} ${solicitacao?.titulo}`}
                          size={'large'}
                          component={Paper}>
            {solicitacao && <Grid container spacing={1} p={1} component={Paper} elevation={2} mt={1} mb={1}>
                <Divider/>
                <Grid size={12}>
                    <SolicitacaoInfo value={solicitacao} variant={'list'}/>
                </Grid>

                <Grid size={12} container alignItems={'center'}>
                    <Typography>Item selecionado:</Typography>
                    {produto != null && <Grid container alignItems={'center'}>
                            <ProdutoInformacaoNavLink value={produto}
                                                      displayMode={'nome'}/>
                            <IconButton onClick={() => {

                                addPopUp({
                                    title: 'Referencias',
                                    content: <SolicitacaoReferenciasPage hideHeader filtersProps={{
                                        filters: {idItem: Number(itemId)}, setFilters: () => {
                                        }
                                    }}/>
                                })
                            }}>
                                <Tooltip title={'Ver referências'}>
                                    <Badge badgeContent={referencias.total}>
                                        {referencias.total == 0 ? <LinkOffOutlined/> : <LinkOutlined/>}
                                    </Badge>
                                </Tooltip>
                            </IconButton>
                            <IconButton onClick={() => {
                                searchParams.delete('produtoId')
                                setSearchParams(searchParams)
                            }}>
                                <Clear/>
                            </IconButton>
                        </Grid> ||
                        <Typography>Nenhum item selecionado</Typography>
                    }
                </Grid>

                <Divider/>
                <Grid size={12}>
                    <Grid container>
                        <Grid size={'grow'}>
                            <Tabs variant={'scrollable'}
                                  value={tab} onChange={
                                (_, v) => navigate({
                                    pathname: location.pathname,
                                    search: location.search,
                                    hash: v,
                                })
                            }>
                                <Tab value={'Detalhes'} label={'Detalhes'}/>
                                <Tab value={'Itens'} label={'Itens'}
                                     icon={<ShoppingBag/>}/>
                                <Tab value={'Movimentacoes'} label={'Movimentações'}
                                     icon={<MoneyOff/>}/>
                                <Tab value={'Orcamentos'}
                                     label={'Orçamentos'}/>

                                {solicitacao.contrato && <Tab value={'Contrato'} label={'Contrato'}/>}
                                {itemSelecionado &&
                                    <Tab value={'DetalhesItem'}
                                         label={`Detalhes '${itemSelecionado.produto?.nome}'`}/>}
                                {orcamentoId && <Tab value={'Orcamento'} label={'Orçamento'}/>}
                                <Tab value={'Logs'}
                                     label={'Logs'}/>
                            </Tabs>
                        </Grid>
                    </Grid>
                    {tab == 'Detalhes' && <Grid>
                        {<Grid>
                            <SolicitacaoInformacaoGrid onUpdate={() => {
                                setRefreshRequested(true)
                            }}
                                                       value={solicitacao}/>
                        </Grid>}
                    </Grid>}
                    {tab == 'Itens' && <Grid size={12} component={Paper} elevation={2} mt={1} p={1}>
                        <SolicitacaoItensPage filtros={{idSolicitacao: [solicitacao.id]}}/>
                    </Grid>}
                    {tab == 'Orcamentos' && <Grid size={12} component={Paper} elevation={2} mt={1}>
                        <OrcamentosPage hideHeader
                                        filtros={{...orcamentoFiltros}}
                                        overrides={{size: "large"}}
                                        slotProps={{
                                            orcamentoInfo: (o) => ({
                                                slotProps: {
                                                    solicitacaoItem: {
                                                        searchData: {
                                                            solicitacaoId: solicitacaoId,
                                                            itemId: o.solicitacaoItemId?.toString() ?? '',
                                                            produtoId: produtoId ?? '',
                                                            orcamentoId: o.id.toString(),
                                                        },
                                                        ignoreNavigate: true,
                                                        onClick: () => {
                                                            navigate({
                                                                pathname: location.pathname,
                                                                search: createSearchParams({
                                                                    solicitacaoId: solicitacaoId ?? '',
                                                                    itemId: o.solicitacaoItemId?.toString() ?? '',
                                                                    produtoId: produtoId ?? '',
                                                                    orcamentoId: o.id.toString(),
                                                                }).toString(),
                                                                hash: 'Orcamento',
                                                            })
                                                        }
                                                    }
                                                },
                                            }),
                                        }}
                        />
                    </Grid>}
                    {(tab == 'Contrato' && solicitacao.contrato) &&
                        <Grid size={12} component={Paper} elevation={2} mt={1}>
                            <ContratoInformacao variant={"list"} value={solicitacao.contrato}/>
                        </Grid>}
                    {tab == 'Movimentacoes' &&
                        <Grid size={12} component={Paper} elevation={2} mt={1}>
                            <RecursosMovimentacoesV2Page filters={{solicitacaoId: [solicitacao.id]}}
                                                         onCreate={() => {
                                                             setRefreshRequested(true);
                                                         }} onUpdate={() => {
                                setRefreshRequested(true);
                            }}/>
                        </Grid>}

                    {tab == 'ItemSelecionado' && itemSelecionado &&
                        <Grid size={12} component={Paper} elevation={2} mt={1}>
                            <OrcamentosPage hideHeader
                                            filtros={{
                                                idSolicitacao: [solicitacao.id],
                                                idItem: [itemSelecionado.produtoId],
                                            }}
                                            overrides={{
                                                size: "large",
                                                titulo: 'Orçamentos do item ' + itemSelecionado.produto?.nome,
                                            }}
                                            slotProps={{
                                                orcamentoInfo: (o) => ({
                                                    slotProps: {
                                                        solicitacaoItem: {
                                                            ignoreNavigate: true,
                                                            onClick: () => {
                                                                navigate({
                                                                    pathname: location.pathname,
                                                                    search: createSearchParams({
                                                                        solicitacaoId: solicitacaoId ?? '',
                                                                        itemId: o.solicitacaoItemId?.toString() ?? '',
                                                                        orcamentoId: o.id.toString(),
                                                                    }).toString(),
                                                                    hash: 'Orcamento',
                                                                })
                                                            }
                                                        }
                                                    },
                                                    EndComponent: (o) => <IconButton size={'small'}
                                                                                     onClick={() => {
                                                                                         if (solicitacaoId)
                                                                                             navigate({
                                                                                                 pathname: location.pathname,
                                                                                                 search: createSearchParams({
                                                                                                     solicitacaoId: solicitacaoId,
                                                                                                     itemId: o.solicitacaoItemId?.toString() ?? '',
                                                                                                     orcamentoId: o.id.toString(),
                                                                                                 }).toString(),
                                                                                                 hash: 'Orcamento',
                                                                                             });
                                                                                     }}
                                                    >
                                                        <TaskAltOutlined/>
                                                    </IconButton>,
                                                }),
                                            }}
                            />
                        </Grid>}
                    {tab == 'DetalhesItem' && itemSelecionado &&
                        <SolicitacaoItemInformacaoGrid sx={{mt: 1.4}} value={itemSelecionado}/>}

                    {tab == 'Orcamento' && <Grid size={12} component={Paper} elevation={2} mt={1}>
                        {<OrcamentoPage/>}</Grid>}
                    {tab == 'Logs' && <Grid size={12} component={Paper} elevation={2} mt={1}>
                        {<SolicitacaoLogsPage solicitacao={solicitacao}/>}</Grid>}
                </Grid>
            </Grid>
            }

        </DefaultContainer>
    )
        ;
}